/**
 * source-badge.js — kleines Quell-Badge fuer Play-while-Download (Z4,
 * Contract 02 §4.1: /play/start liefert source:{kind,progress}).
 *
 * Zeigt beim Abspielen aus einer noch laufenden Quelle (Torrent/RAR) einen
 * Pill mit Download-Fortschritt. Bewusst entkoppelt vom ZapPlayer, damit die
 * Render-Logik isoliert testbar ist (der Player ist nur der Aufrufer).
 *
 * Idempotent: gleicher stage → genau ein Pill, das aktualisiert/entfernt
 * wird. Entfernt sich bei kind!=torrent/rar oder progress>=100 (fertig =
 * normale Datei, kein Badge noetig).
 */

const KIND_LABEL = { torrent: 'Torrent', rar: 'Archiv' };

/**
 * @param {HTMLElement|null} stage  Player-Stage (Badge wird hier eingehaengt)
 * @param {{kind?: string, progress?: number}|null} source  aus /play/start bzw. /state
 * @returns {HTMLElement|null} das Pill-Element (oder null wenn keins gezeigt wird)
 */
export function setSourceBadge(stage, source) {
  if (!stage) return null;
  const existing = stage.querySelector('.zap-source-badge');

  const kind = source?.kind;
  const label = kind ? KIND_LABEL[kind] : null;
  // progress kann fehlen (snapshot ohne Wert) → dann nur das Kind-Label.
  const pct = Number(source?.progress);
  const hasPct = Number.isFinite(pct);
  // Kein Badge wenn: keine streaming-Quelle, oder Quelle fertig (100%) —
  // dann ist es effektiv eine normale Datei.
  const show = !!label && (!hasPct || pct < 100);
  if (!show) {
    existing?.remove();
    return null;
  }

  const pill = existing || (() => {
    const el = document.createElement('div');
    el.className = 'zap-source-badge';
    el.setAttribute('aria-live', 'polite');
    stage.appendChild(el);
    return el;
  })();
  // textContent, nie innerHTML — defensiv, auch wenn die Werte serverseitig sind.
  pill.textContent = hasPct
    ? `↓ ${label} ${Math.max(0, Math.min(99, Math.round(pct)))}%`
    : `↓ ${label}`;
  return pill;
}
